import { Skeleton } from '@/shared/components/ui/skeleton'

export default function LatestActivitiesLoadingState() {
  return (
    <div className="w-full">
      {/* Time Group Header Skeleton */}
      <Skeleton className="h-[12px] w-[80px] mt-[4px] rounded" />

      {/* Activity Card Skeletons */}
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="bg-[#FAFAFA] border border-[#e4e4e7] flex flex-col gap-[4px] items-start pb-[4px] pt-0 px-0 rounded-[12px] w-full mt-[8px]"
        >
          {/* Header Skeleton */}
          <div className="bg-white border-b border-[#e4e4e7] flex gap-[8px] items-center px-[12px] py-[8px] rounded-tl-[12px] rounded-tr-[12px] w-full">
            <Skeleton className="size-[14px] rounded" />
            <Skeleton className="h-[14px] flex-1 max-w-[200px] rounded" />
          </div>

          {/* Activity Items Skeleton */}
          <div className="flex flex-col items-start px-[4px] py-0 w-full">
            {Array.from({ length: 2 }).map((_, itemIndex) => (
              <div key={itemIndex} className="flex gap-[4px] items-start justify-center p-[8px] rounded-[8px] w-full">
                {/* Avatar Skeleton */}
                <Skeleton className="size-[16px] rounded-full shrink-0" />

                {/* Text Content Skeleton */}
                <div className="flex-1 flex flex-col items-start justify-center px-[4px] py-0 gap-[4px]">
                  <Skeleton className="h-[12px] w-full max-w-[250px] rounded" />
                  <Skeleton className="h-[12px] w-full max-w-[180px] rounded" />
                </div>

                {/* Time Skeleton */}
                <div className="flex flex-col items-start pl-[4px] pr-0 py-0 text-right w-[58.75px]">
                  <Skeleton className="h-[11px] w-[40px] ml-auto rounded" />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
